import React from "react";
import { Box, Paper, Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";

const StepIcon = styled(Box)(({ theme, gradient }) => ({
  width: 48,
  height: 48,
  borderRadius: 12,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(1),
  marginLeft: "auto",
  marginRight: "auto",
  background: gradient,
}));

const Connector = styled(Box)(({ theme, gradient }) => ({
  width: 96,
  height: 1,
  background: gradient,
}));

const InfoBox2 = ({ styles }) => {
  const actions = ["Redigera", "Spara", "Dela", "Skriv ut"];

  return (
    <Box
      sx={{
        ...styles.freshBox,
        width: { xs: "100%", md: "700px" },
        p: 4,
        borderRadius: 4,
        margin: "0 auto",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          {/* Step 1 */}
          <Box sx={{ textAlign: "center" }}>
            <StepIcon gradient="linear-gradient(to bottom right, #DBEAFE, #BFDBFE)">
              <DescriptionOutlinedIcon
                sx={{ width: 24, height: 24, color: "#2563EB" }}
              />
            </StepIcon>
            <Typography
              variant="subtitle2"
              sx={{
                color: "text.primary",
                fontSize: "1.1rem",
                fontWeight: "600",
              }}
            >
              Steg 1
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", fontSize: "1rem" }}
            >
              Välj underlag
            </Typography>
          </Box>

          <Connector gradient="linear-gradient(to right, #BFDBFE, #E9D5FF, #C7D2FE)" />

          {/* Step 2 */}
          <Box sx={{ textAlign: "center" }}>
            <StepIcon gradient="linear-gradient(to bottom right, #F3E8FF, #E9D5FF)">
              <AutoFixHighOutlinedIcon
                sx={{ width: 24, height: 24, color: "#9333EA" }}
              />
            </StepIcon>
            <Typography
              variant="subtitle2"
              sx={{
                color: "text.primary",
                fontSize: "1.1rem",
                fontWeight: "600",
              }}
            >
              Steg 2
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", fontSize: "1rem" }}
            >
              Generera
            </Typography>
          </Box>

          <Connector gradient="linear-gradient(to right, #E9D5FF, #C7D2FE, #A5B4FC)" />

          {/* Step 3 */}
          <Box sx={{ textAlign: "center" }}>
            <StepIcon gradient="linear-gradient(to bottom right, #E0E7FF, #C7D2FE)">
              <MenuBookOutlinedIcon
                sx={{ width: 24, height: 24, color: "#4F46E5" }}
              />
            </StepIcon>
            <Typography
              variant="subtitle2"
              sx={{
                color: "text.primary",
                fontSize: "1.1rem",
                fontWeight: "600",
              }}
            >
              Steg 3
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", fontSize: "1rem" }}
            >
              Hantera
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoBox2;
